import React from "react";
import { useStyles } from './FieldListItem.styles';
import { Checkbox } from '@fluentui/react';

interface DropDownListProps {
  label: string;
  id: string;
  selected: boolean;
  onChange: (selected: boolean) => void;
}

export const FieldListItem: React.FC<DropDownListProps> =  (props) => {

  const {label, id, selected, onChange} = props;
  const classes = useStyles();

  return (
    <div className={classes.fieldListItem}>
      <Checkbox checked={selected} onChange={(_, checked) => onChange(!!checked)}/>
      <span onClick={() => onChange(!selected)}>{label}</span>
    </div>
  )
}
